import { useState } from "react";
import { useNavigate } from "react-router";
import { Knopf } from "../design/Kachel";
import { Textfeld } from "../design/Formular";
import { Abweisung, Meldung } from "../design/Hinweis";
import { Eingang } from "../design/Ansicht";
import { zugang } from "../plattform/api";
import { geraetebezeichnungVorschlag } from "../plattform/geraet";
import { usePasskeyzeremonie } from "./passkey";
import { OHNE_NETZ, passkeymeldung } from "./zugangsmeldungen";

/**
 * Wiederherstellung (oberflaeche.md §7, identitaeten.md §6). Verrät nie, ob eine Adresse hinterlegt ist. Der Dienst
 * verbraucht den Einmalcode mit den Optionen; nach einem abgebrochenen Dialog nimmt „Bestätigen“ deshalb dieselbe
 * Zeremonie wieder auf (`Passkeyzeremonie`). Jeder Fehlschlag hat seine Meldung (§9, V-20).
 */
export function Wiederherstellung() {
  const navigate = useNavigate();
  const zeremonie = usePasskeyzeremonie("registrierung");
  const [kontakt, setKontakt] = useState("");
  const [code, setCode] = useState("");
  const [geraet, setGeraet] = useState(geraetebezeichnungVorschlag);
  const [angefordert, setAngefordert] = useState(false);
  const [grund, setGrund] = useState<string | null>(null);
  const [meldung, setMeldung] = useState<string | null>(null);
  const [laeuft, setLaeuft] = useState(false);

  async function senden() {
    setGrund(null);
    setMeldung(null);
    const a = await zugang("wiederherstellung/anfordern", { Adresse: kontakt });
    if (a.ok) setAngefordert(true);
    else if (a.netzfehler) setMeldung(OHNE_NETZ);
    else setGrund(a.grund ?? "unzulaessige-angaben");
  }

  function bestaetigen() {
    setGrund(null);
    setMeldung(null);
    setLaeuft(true);
    void zeremonie.ausfuehren({ zweck: "wiederherstellung", Adresse: kontakt, Einmalcode: code, "Gerätebezeichnung": geraet }).then((r) => {
      setLaeuft(false);
      if (!r.fehler) navigate("/", { replace: true });
      else if (r.fehler === "abgelehnt") setGrund(r.antwort.grund ?? "unzulaessige-angaben");
      else setMeldung(passkeymeldung("wiederherstellung", r.fehler));
    });
  }

  return (
    <Eingang name="Wiederherstellung" titel="Wiederherstellung" unter="Konto wiederherstellen"
      unten={<Knopf symbol="passkey" art="planung" onPress={bestaetigen} isDisabled={laeuft}>Bestätigen</Knopf>}>
      <div className="formular text-bereich">
        <Textfeld label="Wiederherstellungskontakt" wert={kontakt} onChange={setKontakt} hilfe="Telefonnummer oder E-Mail-Adresse" />
        <Knopf symbol="senden" art="planung-zweit" onPress={senden}>Senden</Knopf>
        {angefordert ? <Meldung symbol="info">Falls diese Adresse hinterlegt ist, wurde ein Code gesendet.</Meldung> : null}
        <Textfeld label="Einmalcode" wert={code} onChange={setCode} eingabemodus="numeric" autoComplete="one-time-code" mono />
        <Textfeld label="Gerätebezeichnung" wert={geraet} onChange={setGeraet} />
        <Abweisung grund={grund} />
        {meldung ? <Meldung>{meldung}</Meldung> : null}
      </div>
    </Eingang>
  );
}
